var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-video-animation",style:(_vm.customStyles)},[_c('video',{attrs:{"autoplay":"","muted":"","playsinline":"","loop":_vm.loop,"poster":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.url,"type":_vm.videoType}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }